import React, { useEffect, useState } from 'react';
import { ICompatibilityList } from '../../../models/pro-sites';

interface CompatibilityListProps {
    compatibilityList: ICompatibilityList[];
    designId: number;
}

const CompatibilityList = ({
    compatibilityList,
    designId,
}: CompatibilityListProps) => {
    const [compatibilityMessage, setCompatibilityMessage] = useState('');
    useEffect(() => {
        const productData = compatibilityList.find(
            (item) => item.designId === designId
        );
        if (productData)
            setCompatibilityMessage(productData.compatibilityMessage);
    }, [compatibilityList, designId]);

    return (
        <>
            <span className="flex col-md-6">
                <p className="margin-left">{compatibilityMessage}</p>
            </span>
        </>
    );
};

export default CompatibilityList;
